import React, { useState } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { RenderDatePicker, SelectInput } from 'components/Common/Inputs';
import AutoCompleteInput from 'components/Common/Inputs/AutoCompleteInput';
import RelationshipType from 'common/Customers/RelationshipType';
import { addCustomerLink } from 'actions';
import { toastr } from 'react-redux-toastr';

const AddCustomerLinkForm = ({
  dispatch,
  fromCustomerId,
  isAddingCustomerLink,
  reset
}) => {
  const [toCustomerId, updateToCustomerId] = useState(null);
  const [toCustomerIdFieldKey, updateToCustomerIdFieldKey] = useState(Date.now());
  const [relationshipType, updateRelationshipType] = useState(null);
  const [effectiveFromDate, updateEffectiveFromDate] = useState(null);
  const [effectiveToDate, updateEffectiveToDate] = useState(null);

  const clearFormData = () => {
    // AutoCompleteInput contains a nested <Field> component, and so to reset it we need to re-init the entire subtree
    updateToCustomerIdFieldKey(prev => prev + 1);

    updateToCustomerId(null);
    updateRelationshipType(null);
    updateEffectiveFromDate(null);
    updateEffectiveToDate(null);
    reset();
  };

  const onFormSubmit = (e) => {
    e.preventDefault();

    if (!toCustomerId) {
      toastr.error('', 'Please provide a valid Shareholder ID.');
      return;
    }

    if (!relationshipType) {
      toastr.error('', 'Please select a Relationship Type.');
      return;
    }

    if (!effectiveFromDate) {
      toastr.error('', 'Please select an Effective From date.');
      return;
    }

    if (fromCustomerId && toCustomerId && relationshipType && effectiveFromDate) {
      dispatch(addCustomerLink(fromCustomerId, toCustomerId, relationshipType, effectiveFromDate, effectiveToDate, clearFormData));
    }
  };

  return (<div className="add-customer-link-form panel-body-caption">
    <h2 className="columns"><strong>Link a Shareholder:</strong></h2>
    <form onSubmit={ onFormSubmit }>
      <div className="form-group columns">
        <div className="col-2">
          <label htmlFor="entity-form-id" className="panel-body-label">Shareholder ID *</label>
        </div>
        <div className="col-4" key={ toCustomerIdFieldKey }>
          <AutoCompleteInput
            name="toCustomerId"
            id="link-to-customer-id"
            category="customer"
            className="form-select"
            context={ null }
            placeholder="Enter Shareholder ID..."
            onSelectedItem={ e => updateToCustomerId(e.id) }
            value={ toCustomerId || '' }
          />
        </div>
      </div>
      <div className="form-group columns">
        <div className="col-2">
          <label htmlFor="cp-form-id" className="panel-body-label">Relationship Type *</label>
        </div>
        <div className="col-4">
          <Field
            id="link-relationship-type"
            name="relationshipType"
            component={ SelectInput }
            className="form-select"
            onChange={ e => updateRelationshipType(e.target.value) }
          >
            <option value="" disabled>Select relationship type...</option>
            {RelationshipType.map(rt => (
              <option key={ rt.value } value={ rt.value }>
                {rt.name}
              </option>
            ))}
          </Field>
        </div>
      </div>
      <div className="form-group columns">
        <div className="col-2">
          <label htmlFor="cp-form-id" className="panel-body-label">Effective From *</label>
        </div>
        <div className="col-4">
          <Field
            id="link-effective-from-date"
            component={ RenderDatePicker }
            name="effectiveFrom"
            className="form-input"
            placeholder="MMM DD, YYYY"
            onChange={ (e, date) => updateEffectiveFromDate(date) }
            value={ effectiveFromDate }

          />
        </div>
      </div>
      <div className="form-group columns">
        <div className="col-2">
          <label htmlFor="cp-form-id" className="panel-body-label">Effective To</label>
        </div>
        <div className="col-4">
          <Field
            id="link-effective-to-date"
            component={ RenderDatePicker }
            name="effectiveTo"
            className="form-input"
            placeholder="MMM DD, YYYY"
            onChange={ (e, date) => updateEffectiveToDate(date) }
          />
        </div>
      </div>
      <div className="form-group columns">
        <div className="col-2" />
        <div className="col-6">
          <button
            id="add-cl-submit-btn"
            type="submit"
            className="btn btn-primary"
            disabled={ isAddingCustomerLink }
          >
            { isAddingCustomerLink && <span className="icon loading mr" /> }
            Add Shareholder Link
          </button>
        </div>
      </div>
    </form>
  </div>);
};

AddCustomerLinkForm.propTypes = {
  dispatch: PropTypes.func.isRequired,
  fromCustomerId: PropTypes.number.isRequired,
  isAddingCustomerLink: PropTypes.bool.isRequired,
  reset: PropTypes.func.isRequired
};

AddCustomerLinkForm.defaultProps = {

};

const AddCustomerLinkFormReduxForm = reduxForm({
  form: 'add-customer-link-form'
})(AddCustomerLinkForm);

const mapDispatchToProps = dispatch => ({ dispatch });

function mapStateToProps(state) {
  const {
    isAddingCustomerLink
  } = state;

  return {
    isAddingCustomerLink
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddCustomerLinkFormReduxForm);
